import { render } from "./VtoPageLanding.vue?vue&type=template&id=f01922d8"
import script from "./VtoPageLanding.vue?vue&type=script&lang=js"
export * from "./VtoPageLanding.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__